<template>
  <div class="bg-light h-max-content">
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="container-fluid p-0">
      <USRiskManagementFilters class="mx-2" />

      <b-tabs card v-model="selectedDashboardCategory" lazy v-if="corporateGroupSelected">
        <b-tab
          :title="dashboardCategories.risk.v"
          :active="selectedDashboardCategory === 'risk'"
        >
          <div class="col-md-12 d-flex justify-content-end mb-3">
            <b-button
              variant="secondary"
              @click="exportToExcel()"
              :disabled="loadingExport || !corporateGroupSelected"
              class="btn-export-excel"
            >
              {{ loadingExport ? 'Gerando...' : 'Ações de Melhoria(xlsx)' }}
              <font-awesome-icon
                    icon="download"
                    :color="corporateGroupSelected ? '#007bff' : '#b5b5b5'"
                  />
            </b-button>
          </div>
          <b-row class="mb-4">
            <b-col xl="3">
              <div class="box p-4 shadow position-relative" style="height: 100%; max-height: 200px;">
                <span class="text-black m-0">Máquinas</span>
                <b-button
                  @click="exportMachinesToExcel"
                  :disabled="!corporateGroupSelected || loadingExport"
                  :style="{
                    position: 'absolute',
                    right: '24px',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: corporateGroupSelected ? 'pointer' : 'not-allowed'
                  }"
                >
                  <font-awesome-icon
                    icon="download"
                    :color="corporateGroupSelected ? '#007bff' : '#b5b5b5'"
                  />
                </b-button>

                <div class="kpi-chart position-relative" style="height: 104px">
                  <span
                    class="position-absolute text-black m-0 kpi-chart__text"
                  >
                    {{ machineCountSpark.data && machineCountSpark.data.total ? machineCountSpark.data.total : 0 }}
                  </span>
                </div>
              </div>
            </b-col>

            <b-col xl="3">
              <div class="box p-4 shadow position-relative" style="height: 100%; max-height: 200px;">
                <span class="text-black m-0">Riscos</span>

                <b-button
                  @click="exportHazardsToExcel"
                  :disabled="!corporateGroupSelected || loadingExport"
                  :style="{
                    position: 'absolute',
                    right: '24px',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: corporateGroupSelected ? 'pointer' : 'not-allowed'
                  }"
                >
                  <font-awesome-icon
                    icon="download"
                    :color="corporateGroupSelected ? '#007bff' : '#b5b5b5'"
                  />
                </b-button>
                <div class="kpi-chart position-relative" style="height: 104px">
                  <span
                    class="position-absolute text-black m-0 kpi-chart__text"
                  >
                    {{ hazardsSpark.data && hazardsSpark.data.total ? hazardsSpark.data.total : 0 }}
                  </span>
                </div>
              </div>
            </b-col>
            <b-col xl="3">
              <div class="box p-4 shadow position-relative" style="height: 100%; max-height: 200px;">
                <span class="text-black m-0">Ações de Melhoria <b>Pendentes</b></span>
                <b-button
                  @click="exportToExcel('Pendente')"
                  :disabled="!corporateGroupSelected || loadingExport"
                  :style="{
                    position: 'absolute',
                    right: '24px',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: corporateGroupSelected ? 'pointer' : 'not-allowed'
                  }"
                >
                  <font-awesome-icon
                    icon="download"
                    :color="corporateGroupSelected ? '#007bff' : '#b5b5b5'"
                  />
                </b-button>
                <div class="kpi-chart position-relative" style="height: 104px">
                  <span
                    class="position-absolute text-black m-0 kpi-chart__text"
                  >
                    {{ pendingImprovementActionsSpark.data && pendingImprovementActionsSpark.data.total ? pendingImprovementActionsSpark.data.total : 0 }}
                  </span>
                </div>
              </div>
            </b-col>
            <b-col xl="3">
              <div class="box box2 p-4 shadow position-relative">
                <span class="text-black m-0">Ações de Melhoria <b>Finalizadas</b></span>
                <b-button
                  @click="exportToExcel('Executada')"
                  :disabled="!corporateGroupSelected || loadingExport"
                  :style="{
                    position: 'absolute',
                    right: '24px',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: corporateGroupSelected ? 'pointer' : 'not-allowed'
                  }"
                >
                  <font-awesome-icon
                    icon="download"
                    :color="corporateGroupSelected ? '#007bff' : '#b5b5b5'"
                  />
                </b-button>
                <div class="kpi-chart position-relative" style="height: 104px">
                  <span
                    class="position-absolute text-black m-0 kpi-chart__text"
                  >
                    {{ finishedImprovementActionsSpark.data && finishedImprovementActionsSpark.data.total ? finishedImprovementActionsSpark.data.total : 0 }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col xl="4" class="mb-4">
              <div class="bg-white p-4 rounded shadow">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="text-muted font-weight-bold">Riscos Antes das Ações de Melhoria</h6>
                  </div>
                  <div class="d-flex align-items-center">
                    <router-link
                      to="/admin/RiskManagement/Details?selected=Comparação de Riscos"
                      style="display: none;"
                    >
                      <a href="#" class="btn btn-link p-0 font-xs"
                        >Ver detalhes</a
                      >
                    </router-link>
                  </div>
                </div>

                <apexchart
                  data-chart-key="category_before"
                  id="category_before"
                  type="pie"
                  :height="325"
                  :options="getPieChartOptions('category_before')"
                  :series="pieChart.series.before.series"
                ></apexchart>
              </div>
            </b-col>

            <b-col xl="4" class="mb-4">
              <div class="bg-white p-4 rounded shadow">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="text-muted font-weight-bold">Riscos Durante as Ações de Melhoria</h6>
                  </div>
                  <div class="d-flex align-items-center">
                    <router-link
                      to="/admin/RiskManagement/Details?selected=Comparação de Riscos"
                      style="display: none;"
                    >
                      <a href="#" class="btn btn-link p-0 font-xs"
                        >Ver detalhes</a
                      >
                    </router-link>
                  </div>
                </div>

                <apexchart
                  data-chart-key="category_current"
                  id="category_current"
                  type="pie"
                  :height="325"
                  :options="getPieChartOptions('category_current')"
                  :series="pieChart.series.current.series"
                ></apexchart>
              </div>
            </b-col>

            <b-col xl="4" class="mb-4">
              <div class="bg-white p-4 rounded shadow">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="text-muted font-weight-bold">
                      Riscos Após as Ações de Melhoria
                    </h6>
                  </div>
                    <div class="d-flex align-items-center">
                      <router-link
                        to="/admin/RiskManagement/Details?selected=Comparação de Riscos"
                        style="display: none;"
                      >
                        <a href="#" class="btn btn-link p-0 font-xs"
                          >Ver detalhes</a
                        >
                      </router-link>
                    </div>
                </div>

                <apexchart
                  data-chart-key="category_after"
                  id="category_after"
                  type="pie"
                  :height="325"
                  :options="getPieChartOptions('category_after')"
                  :series="pieChart.series.after.series"
                ></apexchart>
              </div>
            </b-col>

            <b-col xl="12" class="mb-4">
              <div class="bg-white p-4 rounded shadow">
                <div class="d-flex justify-content-between">
                  <h6 class="text-muted font-weight-bold">
                    Comparação de Riscos
                  </h6>
                  <router-link
                    to="/admin/RiskManagement/Details?selected=Comparação de Riscos"
                    style="display: none;"
                  >
                    <a href="#" class="btn btn-link p-0 font-xs"
                      >Ver detalhes</a
                    >
                  </router-link>
                </div>

                <apexchart
                  type="line"
                  :height="314"
                  :options="lineChartOptions"
                  :series="lineChartSeries"
                ></apexchart>
              </div>
            </b-col>

            <b-col xl="12" class="mb-12 d-none">
              <div class="bg-white p-4 rounded shadow">
                <div class="d-flex justify-content-between">
                  <h6 class="text-muted font-weight-bold">
                    Comparação de Riscos
                  </h6>
                  <router-link
                    to="/admin/RiskManagement/Details?selected=Comparação de Riscos"
                    style="display: none;"
                  >
                    <a href="#" class="btn btn-link p-0 font-xs"
                      >Ver detalhes</a
                    >
                  </router-link>
                </div>

                <apexchart
                  type="bar"
                  :height="314"
                  :options="risksPercentageByHazard.options"
                  :series="risksPercentageByHazard.series"
                ></apexchart>
              </div>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          :title="dashboardCategories.strategic.v"
          :active="selectedDashboardCategory === 'strategic'"
        >
          <div v-if="loadingStrategicView">
            <b-spinner type="border" small></b-spinner>
          </div>
          <div v-else>
            <div class="row sparkboxes mt-4 mb-4 justify-content-between">
              <div class="col-xl-2">
                <div class="box box2 p-4 shadow">
                  <span class="text-black m-0">Qtd. Máquinas</span>
                  <div class="kpi-chart position-relative" style="height: 104px">
                    <span
                      class="position-absolute text-black m-0 kpi-chart__text"
                      >{{ machinesCountByMonth.data?.total ?? 0 }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="col-xl-2">
                <div class="box box4 p-4 shadow">
                  <span class="text-black m-0">Total Planejado</span>
                  <div class="kpi-chart position-relative" style="height: 104px">
                    <span
                      class="position-absolute text-black m-0 kpi-chart__text d-inline-flex"
                      ><span class="font-xs">R$</span
                      >{{ formatCurrency(totalPlanejado) }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="col-xl-2">
                <div class="box box3 p-4 shadow">
                  <span class="text-black m-0">Valor Investido</span>

                  <div class="kpi-chart position-relative" style="height: 104px">
                    <span
                      class="position-absolute text-black m-0 kpi-chart__text d-inline-flex"
                      ><span class="font-xs">R$</span>
                      {{ formatCurrency(totalInvestedByMonth?.data?.total) }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="col-xl-2">
                <div class="box box4 p-4 shadow">
                  <span class="text-black m-0">Valor à Investir</span>
                  <div class="kpi-chart position-relative" style="height: 104px">
                    <span
                      class="position-absolute text-black m-0 kpi-chart__text d-inline-flex"
                      ><span class="font-xs">R$</span
                      >{{ formatCurrency(valorAInvestir) }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="col-xl-2">
                <div class="box box1 p-4 shadow">
                  <span class="text-black m-0">Percentual à investir</span>
                  <div class="kpi-chart position-relative" style="height: 104px">
                    <span
                      class="position-absolute text-black m-0 kpi-chart__text d-inline-flex"
                      >{{ formatPercentage(percentualAInvestir) }}
                      <span class="font-xs">%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <br/>

            <div class="bg-white p-4 rounded shadow">
              <div class="d-flex justify-content-between">
                <h6 class="text-muted font-weight-bold">
                  Investimentos Pendentes
                </h6>
                <router-link
                  to="/admin/RiskManagement/Details?selected=Investimentos Pendentes"
                  style="display: none;"
                >
                  <a href="#" class="btn btn-link p-0 font-xs">
                    Ver detalhes
                  </a>
                </router-link>
              </div>
              <apexchart
                ref="current-risk-distribution-mixed-chart"
                type="line"
                height="350"
                :options="machinesCountAndInvestmentsByHazard.options"
                :series="machinesCountAndInvestmentsByHazard.series"
                @updated="updateChartColor"
              />
            </div>

            <div class="bg-white p-4 rounded shadow mt-4">
              <div class="d-flex justify-content-between">
                <h6 class="text-muted font-weight-bold">
                  Investimento Total
                </h6>
              </div>
              <apexchart
                type="line"
                height="350"
                :options="totalInvestmentOptions"
                :series="totalInvestmentSeries"
              />
            </div>

            <div class="row gx-2">
              <div class="col-xl-8 col-12">
                <div class="bg-white p-4 rounded shadow mt-4">
                  <div class="d-flex justify-content-between">
                    <h6 class="text-muted font-weight-bold">
                      Investimentos Realizados
                    </h6>
                    <router-link
                      to="/admin/RiskManagement/Details?selected=Investimentos Realizados"
                      style="display: none;"
                    >
                      <a href="#" class="btn btn-link p-0 font-xs">
                        Ver detalhes
                      </a>
                    </router-link>
                  </div>
                  <apexchart
                    type="bar"
                    height="350"
                    :options="investmentOptions"
                    :series="investmentSeries"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-12">
                <div class="bg-white p-4 rounded shadow mt-4 height-fix">
                  <div class="d-flex justify-content-between">
                    <h6 class="text-muted font-weight-bold">
                      Percentual Investido
                    </h6>
                    <router-link
                      to="/admin/RiskManagement/Details?selected=Investimentos Realizados"
                      style="display: none;"
                    >
                      <a href="#" class="btn btn-link p-0 font-xs">
                        Ver detalhes
                      </a>
                    </router-link>
                  </div>
                  <apexchart
                    type="bar"
                    :options="investedPercentileByHazard.options"
                    :series="investedPercentileByHazard.series"
                  >
                  </apexchart>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import {
  getMachinesCountByMonthApi,
  getTotalInvestedByMonthApi,
  getTotalToInvestByMonthApi,
  getTotalToInvestPercentageByMonthApi,
} from "@/api/admin/company-report";
import USRiskManagementFilters from "@/components/RiskManagement/USRiskManagementFilters";
import { HazardLevel } from "@/enum/HazardLevel";
import {
  fetchActionPlansByLast12Months,
  fetchHazardsByLast12Months,
  fetchInvestedPercentileByHazard,
  fetchMachinesCountAndInvestmentsByHazard,
  fetchRisksPercentageByHazard,
} from "@/services/risk-management";
import { types as companyReportTypes } from "@/store/modules/company-report";
import axios from "@/api/axios";
import { mapState } from "vuex";
import { formatCurrency, formatPercentage } from "@/utils/formatCurrency";
export default {
  name: "RiskManagement",

  components: {
    USRiskManagementFilters,
  },

  mounted() {
    window.vueApp = this;
  },

  data() {
    return {
      loadingExport: false,
      labelTranslations: {
        "Aceitável": "acceptable",
        "Baixo": "low",
        "Moderado": "moderate",
        "Significativo": "significant",
        "Alto": "high",
        "Muito Alto": "very_high",
        "Extremo": "extreme"
      },

      pendingImprovementActionsSpark: {
        options: {
          chart: {
            id: "pendingImprovementActionsSpark",
            // group: "sparklines",
            type: "area",
            sparkline: {
              enabled: true,
            },
          },
          stroke: {
            curve: "straight",
          },
          fill: {
            opacity: 0.45,
          },
          yaxis: {
            show: false,
            min: 0,
          },
          labels: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          colors: ["#DCE6EC"],
        },
        series: [
          {
            name: "Ações de Melhoria",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      finishedImprovementActionsSpark: {
        options: {
          chart: {
            id: "finishedImprovementActionsSpark",
            // group: "sparklines",
            type: "area",
            sparkline: {
              enabled: true,
            },
          },
          stroke: {
            curve: "straight",
          },
          fill: {
            opacity: 0.45,
          },
          yaxis: {
            show: false,
            min: 0,
          },
          labels: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          colors: ["#DCE6EC"],
        },
        series: [
          {
            name: "Ações de Melhoria",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      machineCountSpark: {
        options: {
          chart: {
            id: "machineCountSpark",
            // group: "sparklines",
            type: "area",
            sparkline: {
              enabled: true,
            },
          },
          stroke: {
            curve: "straight",
          },
          fill: {
            opacity: 0.45,
          },
          yaxis: {
            show: false,
            min: 0,
          },
          labels: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          colors: ["#DCE6EC"],
        },
        series: [
          {
            name: "Máquinas",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      hazardsSpark: {
        options: {
          chart: {
            id: "hazardsSpark",
            // group: "sparklines",
            type: "area",
            sparkline: {
              enabled: true,
            },
          },
          stroke: {
            curve: "straight",
          },
          fill: {
            opacity: 0.45,
          },
          yaxis: {
            show: false,
            min: 0,
          },
          labels: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          colors: ["#DCE6EC"],
        },
        series: [
          {
            name: "Riscos",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },

      hazardsByLast12Months: {
        loading: false,
      },

      lineChartOptions: {
        chart: {
          type: "line",
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          type: "solid",
          opacity: [0.35, 0.35],
        },
        xaxis: {
          categories: [
            "Aceitável",
            "Baixo",
            "Moderado",
            "Significativo",
            "Alto",
            "Muito Alto",
            "Extremo",
          ],

          labels: {
            style: {
              colors: [
                "#92D050",
                "#00B0F0",
                "#F7C500",
                "#FFC000",
                "#E36C0A",
                "#FF0000",
                "#000000",
              ],
              fontWeight: "bold",
              fontSize: "12px",
            },
          },
        },
        colors: ["#6c757d", "#080", "#17a2b8"],
      },
      lineChartSeries: [
        {
          type: "area",
          name: "Antes",
          data: [],
        },
        {
          type: "area",
          name: "Durante",
          data: [],
        },
        {
          type: "area",
          name: "Após",
          data: [],
        },
      ],
      pieChart: {
        options: {
          chart: {
            toolbar: {
              show: true,
              tools: {
                download: false,
              },
            },
            type: "pie",
          },
          legend: {
            show: true,
            position: "right",
            onItemClick: { toggleDataSeries: false },
            formatter: function(label) {
              const hasUnitSelected = !!window?.vueApp?.corporateGroupSelected?.id;
              const downloadClass = hasUnitSelected ? "" : "is-disabled";
              const tooltip = hasUnitSelected
                ? "Baixar dados deste nível de risco"
                : "Selecione uma unidade para habilitar o download";

              return `
                <span class="pie-legend-item">
                  <span class="pie-legend-label">${label}</span>
                  <span
                    class="pie-legend-download ${downloadClass}"
                    title="${tooltip}"
                    role="button"
                    aria-label="Download dos dados de ${label}"
                  >
                    ⬇
                  </span>
                </span>
              `;
            },
          },
          labels: [
            "Aceitável",
            "Baixo",
            "Moderado",
            "Significativo",
            "Alto",
            "Muito Alto",
            "Extremo",
          ],
          colors: [
            "#92D050",
            "#00B0F0",
            "#FFFF00",
            "#FFC000",
            "#E36C0A",
            "#FF0000",
            "#000000",
          ],
          dataLabels: {
            formatter: function (val, opts) {
              const seriesVal = opts?.w?.config?.series?.[opts.seriesIndex];
              if (typeof seriesVal === "number") {
                return `${seriesVal.toFixed(2)}%`;
              }
              return `${val.toFixed(2)}%`;
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return `${val.toFixed(2)}%`;
              },
            },
          },
        },
        series: {
          before: {
            series: [0, 0, 0, 0, 0, 0, 0],
          },
          after: {
            series: [0, 0, 0, 0, 0, 0, 0],
          },
          current: {
            series: [0, 0, 0, 0, 0, 0, 0],
          },
        },
      },
      loadingStrategicView: false,
      machinesCountByMonth: {
        data: null,
        loading: false,
        series: [],
        options: {
          chart: {
            sparkline: { enabled: true },
          },
          stroke: { curve: "straight" },
          grid: {
            padding: {
              top: 40,
            },
          },
          colors: ["#F0AD4E"],
        },
      },
      machinesCountAndInvestmentsByHazard: {
        data: null,
        loading: false,
        series: [
          {
            name: "Valor Pendente",
            type: "column",
            data: [0, 0, 0, 0, 0, 0, 0],
            yAxis: 0,
          },
          {
            name: "Quantidade de Máquinas",
            type: "line",
            data: [0, 0, 0, 0, 0, 0, 0],
            yAxis: 1,
          },
        ],
        options: {
          stroke: {
            show: true,
            width: [0, 3],
            colors: ["transparent", "#0000FF"],
          },
          chart: {
            id: "mixed-chart",
            stacked: false,
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            categories: [
              "Aceitável",
              "Baixo",
              "Moderado",
              "Significativo",
              "Alto",
              "Muito Alto",
              "Extremo",
            ],
            tickPlacement: "on",
          },
          colors: ["black", "#0000FF"],
          dataLabels: {
            style: {
              colors: ["#000"],
            },
            background: {
              enabled: false,
            },
            enabled: true,
            formatter: function (val, opts) {
              if (opts.seriesIndex === 0) {
                return val.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                });
              }
              return val;
            },
          },
          legend: {
            show: false,
            labels: {
              colors: "#333",
            },
          },
          tooltip: {
            y: {
              formatter: function (value, { seriesIndex }) {
                if (seriesIndex === 0) {
                  return value.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  });
                }
                return value;
              },
            },
          },
          yaxis: [
            {
              min: 0,
              labels: {
                formatter: function (val) {
                  return val.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  });
                },
              },
            },
          ],
        },
      },
      totalInvestedByMonth: {
        data: {
          total: 0,
        },
        loading: false,
        series: [
          {
            name: "Investimento",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        options: {
          chart: {
            sparkline: { enabled: true },
          },
          stroke: { curve: "straight" },
          grid: {
            padding: {
              top: 40,
            },
          },
          colors: ["#F0AD4E"],
        },
      },
      totalToInvestByMonth: {
        data: {
          total: 0,
        },
        loading: false,
        series: [
          {
            name: "Investimento",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        options: {
          chart: {
            sparkline: { enabled: true },
          },
          stroke: { curve: "straight" },
          grid: {
            padding: {
              top: 40,
            },
          },
          colors: ["#F0AD4E"],
        },
      },
      hazardColors: {
        Aceitável: "#92D050",
        Baixo: "#00B0F0",
        Moderado: "#FFFF00",
        Significativo: "#FFC000",
        Alto: "#E36C0A",
        "Muito Alto": "#FF0000",
        Extremo: "#000000",
      },
      totalToInvestPercentageByMonth: {
        data: null,
      },
      investedPercentileByHazard: {
        data: null,
        loading: false,
        series: [
          {
            name: "Percentual Investido (%)",
            data: [0, 0, 0, 0, 0, 0, 0],
          },
        ],
        options: {
          plotOptions: {
            bar: {
              barHeight: "100%",
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
            textAnchor: "start",
            style: {
              colors: ["#fff"],
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
            },
            offsetX: 0,
            dropShadow: {
              enabled: true,
            },
          },
          colors: [
            "#92D050",
            "#00B0F0",
            "#FFFF00",
            "#FFC000",
            "#E36C0A",
            "#FF0000",
            "#000000",
          ],
          xaxis: {
            categories: [
              "Aceitável",
              "Baixo",
              "Moderado",
              "Significativo",
              "Alto",
              "Muito Alto",
              "Extremo",
            ],
            max: 100,
            tickPlacement: "on",
          },
          legend: {
            show: false,
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
            y: {
              title: {
                formatter: function () {
                  return "";
                },
              },
            },
          },
        },
      },
      risksPercentageByHazard: {
        data: null,
        loading: false,
        options: {
          colors: ["#6c757d", "#080", "#17a2b8"],
          chart: {
            height: 350,
          },
          xaxis: {
            categories: [
              "Aceitável",
              "Baixo",
              "Moderado",
              "Significativo",
              "Alto",
              "Muito Alto",
              "Extremo",
            ],

            labels: {
              style: {
                colors: [
                  "#92D050",
                  "#00B0F0",
                  "#F7C500",
                  "#FFC000",
                  "#E36C0A",
                  "#FF0000",
                  "#000000",
                ],
                fontWeight: "bold",
                fontSize: "12px",
              },
            },
          },
        },
        series: [
          {
            name: "Antes",
            data: [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Durante",
            data: [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "Após",
            data: [0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      investmentsByHazard: {
        data: null,
        loading: false,
        series: [],
        options: {
          chart: {
            zoom: {
              enabled: false,
            },
            sparkline: { enabled: true },
          },
          stroke: { curve: "straight" },
          grid: {
            padding: {
              top: 40,
            },
          },
          colors: ["#F0AD4E"],
        },
      },
      selectedDashboardCategory: 0,
      dashboardCategories: {
        risk: {
          id: 0,
          v: "Riscos",
        },
        strategic: {
          id: 1,
          v: "Estratégico",
        },
      },
      investmentSeries: [
        {
          name: "Investimento (R$)",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      totalInvestmentSeries: [
        {
          name: "Investimento Total (R$)",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      totalInvestmentOptions: {
        chart: {
          id: "total-investment-chart",
          type: "line",
          zoom: { enabled: false },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        xaxis: {
          categories: [
            "Aceitável",
            "Baixo",
            "Moderado",
            "Significativo",
            "Alto",
            "Muito Alto",
            "Extremo",
          ],
          labels: {
            colors: [
              "#92D050",
              "#00B0F0",
              "#FFFF00",
              "#FFC000",
              "#E36C0A",
              "#FF0000",
              "#000000",
            ],
            style: {
              fontWeight: "bold",
              fontSize: "12px",
            },
          },
        },
        colors: ["#17a2b8"],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            });
          },
        },
        yaxis: {
          min: 0,
          labels: {
            formatter: function (val) {
              return val.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },
        legend: {
          show: false,
        },
      },
      investmentOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        stroke: {
          width: [0, 4],
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            "Aceitável",
            "Baixo",
            "Moderado",
            "Significativo",
            "Alto",
            "Muito Alto",
            "Extremo",
          ],
          labels: {
            colors: [
              "#92D050",
              "#00B0F0",
              "#FFFF00",
              "#FFC000",
              "#E36C0A",
              "#FF0000",
              "#000000",
            ],
            formatter: function (val) {
              return val.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            },
          },
        },
        dataLabels: {
          style: {
            colors: ["#fff"],
          },
          enabled: true,
          formatter: function (val, opts) {
            if (opts.seriesIndex === 0) {
              return val.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            }
            return val;
          },
        },
        colors: [
          "#92D050",
          "#00B0F0",
          "#FFFF00",
          "#FFC000",
          "#E36C0A",
          "#FF0000",
          "#000000",
        ],
        yaxis: [
          {
            title: {
              text: "Investimento (R$)",
            },
          },
        ],
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 4,
            borderRadiusApplication: "end",
            horizontal: true,
          },
        },
      },
      breadcrumbItems: [
        { text: "Início", to: "/admin/Home" },
        { text: "Gestão de Riscos", active: true },
      ],
      sparkOptions: {
        chart: {
          group: "sparks",
          type: "line",
          sparkline: { enabled: true },
          dropShadow: { enabled: true, top: 1, left: 1, blur: 2, opacity: 0.5 },
          height: 80,
        },
        stroke: { curve: "smooth" },
        markers: { size: 0 },
        grid: {
          padding: {
            top: 40,
          },
        },
        colors: ["#F0AD4E"],
        tooltip: {
          x: { show: false },
          y: { title: { formatter: () => "" } },
        },
      },
      actionPlansByLast12Months: {
        loading: false,
        data: null,
        series: [],
      },
    };
  },

  computed: {
    ...mapState(companyReportTypes.STORE_MODULE, {
      unit: companyReportTypes.UNIT,
      businessType: companyReportTypes.BUSINESS_TYPE,
      sector: companyReportTypes.SECTOR,
      machine: companyReportTypes.MACHINE,
      corporateGroup: companyReportTypes.CORPORATE_GROUP,
    }),

    unitSelected() {
      return this.unit.selected;
    },
    businessTypeSelected() {
      return this.businessType.selected;
    },
    sectorSelected() {
      return this.sector.selected;
    },
    machineSelected() {
      return this.machine.selected;
    },
    corporateGroupSelected() {
      return this.corporateGroup.selected;
    },
    selectedFilters() {
      return [
        this.corporateGroupSelected,
        this.businessTypeSelected,
        this.sectorSelected,
        this.machineSelected,
        this.unitSelected,
      ];
    },
    valorAInvestir() {
      return this.totalToInvestByMonth?.data?.total ?? 0;
    },
    totalPlanejado() {
      return (this.totalInvestedByMonth?.data?.total ?? 0) + this.valorAInvestir;
    },
    percentualAInvestir() {
      return this.totalToInvestPercentageByMonth?.data ?? 0;
    },
  },

  methods: {
    formatCurrency,
    formatPercentage,
    /**
     * Reseta os dados dos cards KPI para zero
     */
    resetKpiCards() {
      this.$set(this.machineCountSpark, 'data', { total: 0 });
      this.$set(this.hazardsSpark, 'data', { total: 0 });
      this.$set(this.pendingImprovementActionsSpark, 'data', { total: 0 });
      this.$set(this.finishedImprovementActionsSpark, 'data', { total: 0 });
    },

    /**
     * Reseta os dados dos gráficos para zero
     */
    resetCharts() {
      const emptyHazardData = [0, 0, 0, 0, 0, 0, 0];

      this.pieChart.series.before.series = emptyHazardData;
      this.pieChart.series.after.series = emptyHazardData;
      this.pieChart.series.current.series = emptyHazardData;

      this.lineChartSeries = [
        { name: "Antes", data: emptyHazardData },
        { name: "Durante", data: emptyHazardData },
        { name: "Após", data: emptyHazardData },
      ];

      this.totalInvestmentSeries = [
        { name: "Investimento Total (R$)", data: emptyHazardData },
      ];
    },

    /**
     * Carrega os dados baseado na aba selecionada
     */
    async loadDataByCategory() {
      if (this.selectedDashboardCategory === 0) {
        if (!this.risksPercentageByHazard.loading && this.corporateGroupSelected) {
          await this.loadRisksData();
        }
      } else if (this.selectedDashboardCategory === 1) {
        await this.loadStrategicData();
      }
    },

    async handlePieLegendClick(pieType, label) {
      if (pieType === "category_current") {
        return;
      }

      try {
        this.loadingExport = true;

        const translatedLabel = this.labelTranslations[label] || label;

        const dynamicParam = pieType ? { [pieType]: translatedLabel } : {};

        const response = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/export/machines-actions`,
          {
            params: {
              corporate_group_id: this.corporateGroupSelected?.id,
              company_id: this.unitSelected?.id,
              machine_id: this.machineSelected?.id,
              sector: this.sectorSelected,
              business_type: this.businessTypeSelected,
              ...dynamicParam,
            },
            responseType: 'blob'
          }
        );

        const fileName = `Acoes_de_Melhoria_${pieType}_${label}_${new Date()
          .toISOString()
          .split("T")[0]}.xlsx`;

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$bvToast.toast("Excel gerado com sucesso!", {
          title: "Sucesso",
          toaster: "b-toaster-top-right",
          solid: true,
          variant: "success",
          autoHideDelay: 3000
        });

      } catch (error) {
        console.error("Erro ao exportar:", error);

        this.$bvToast.toast("Erro ao gerar o Excel. Tente novamente.", {
          title: "Erro",
          toaster: "b-toaster-top-right",
          solid: true,
          variant: "danger",
          autoHideDelay: 5000
        });

      } finally {
        this.loadingExport = false;
      }
    },

    handlePieDownloadAll(pieType) {
      if (!this.unitSelected?.id) {
        this.$bvToast.toast("Selecione uma unidade para exportar.", {
          title: "Atenção",
          toaster: "b-toaster-top-right",
          solid: true,
          variant: "warning",
          autoHideDelay: 4000,
        });
        return;
      }

      this.handlePieLegendClick(pieType, "all");
    },

    async exportHazardsToExcel() {
      try {
        this.loadingExport = true;
        
        const response = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/export/machines-actions`,
          {
            params: {
              company_id: this.unitSelected?.id,
              corporate_group_id: this.corporateGroupSelected?.id,
              machine_id: this.machineSelected?.id,
              sector: this.sectorSelected,
              business_type: this.businessTypeSelected,
            },
            responseType: 'blob'
          }
        );

        // Criar link para download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `acoes_de_melhoria_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$bvToast.toast(
          'Excel gerado com sucesso!',
          {
            title: 'Sucesso',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "success",
            autoHideDelay: 3000
          }
        );
      } catch (error) {
        console.error('Erro ao exportar:', error);
        this.$bvToast.toast(
          'Erro ao gerar o Excel. Tente novamente.',
          {
            title: 'Erro',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "danger",
            autoHideDelay: 5000
          }
        );
      } finally {
        this.loadingExport = false;
      }
    },

    async exportMachinesToExcel() {
      try {
        this.loadingExport = true;
        
        const response = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/export/machines`,
          {
            params: {
              company_id: this.unitSelected?.id,
              corporate_group_id: this.corporateGroupSelected?.id,
              machine_id: this.machineSelected?.id,
              sector: this.sectorSelected,
              business_type: this.businessTypeSelected,
            },
            responseType: 'blob'
          }
        );

        // Criar link para download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `maquinas_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$bvToast.toast(
          'Excel gerado com sucesso!',
          {
            title: 'Sucesso',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "success",
            autoHideDelay: 3000
          }
        );
      } catch (error) {
        console.error('Erro ao exportar:', error);
        this.$bvToast.toast(
          'Erro ao gerar o Excel. Tente novamente.',
          {
            title: 'Erro',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "danger",
            autoHideDelay: 5000
          }
        );
      } finally {
        this.loadingExport = false;
      }
    },
    getPieChartOptions(pieType) {
      return {
        ...this.pieChart.options,
        chart: {
          ...this.pieChart.options.chart,
          events: {
            legendClick: (_chartContext, seriesIndex, config) => {
              const label = config?.config?.labels?.[seriesIndex];
              const app = window?.vueApp;

              if (pieType === "category_current") {
                return false;
              }

              if (!label) {
                console.error("Não foi possível identificar a legenda do gráfico.", {
                  pieType,
                  label,
                });
                return false;
              }

              if (!app?.corporateGroupSelected?.id) {
                app?.$bvToast?.toast("Selecione uma unidade para exportar.", {
                  title: "Atenção",
                  toaster: "b-toaster-top-right",
                  solid: true,
                  variant: "warning",
                  autoHideDelay: 4000,
                });
                return false;
              }

              app.handlePieLegendClick(pieType, label);
              return false;
            },
          },
        },
      };
    },
    async exportToExcel(status) {
      try {
        this.loadingExport = true;
        
        const response = await axios.get(
          `${process.env.VUE_APP_API_HOST}/api/export/machines-actions`,
          {
            params: {
              company_id: this.unitSelected?.id,
              machine_id: this.machineSelected?.id,
              sector: this.sectorSelected,
              business_type: this.businessTypeSelected,
              corporate_group_id: this.corporateGroupSelected?.id,
              ...(status ? { status } : {})
            },
            responseType: 'blob'
          }
        );

        // Criar link para download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Maquinas_APR_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return this.$bvToast.toast(
          'Excel gerado com sucesso!',
          {
            title: 'Sucesso',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "success",
            autoHideDelay: 3000
          }
        );
      } catch (error) {
        console.error('Erro ao exportar:', error);
        this.$bvToast.toast(
          'Erro ao gerar o Excel. Tente novamente.',
          {
            title: 'Erro',
            toaster: "b-toaster-top-right",
            solid: true,
            variant: "danger",
            autoHideDelay: 5000
          }
        );
      } finally {
        this.loadingExport = false;
      }
    },
    async loadInvestedPercentileByHazard() {
      if (this.investedPercentileByHazard.loading) {
        return;
      }
      try {
        this.investedPercentileByHazard.loading = true;
        const res = await fetchInvestedPercentileByHazard({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.investedPercentileByHazard.data = data;
        const values = Object.values(data.investedPercentileByHazard);
        const seriesData = values.map((item) => item.percent);
        this.investedPercentileByHazard.series = [
          {
            ...this.investedPercentileByHazard.series[0],
            data: seriesData,
          },
        ];
      } finally {
        this.investedPercentileByHazard.loading = false;
      }
    },

    async loadActionPlansByLast12Months() {
      if (this.actionPlansByLast12Months.loading) {
        return;
      }
      try {
        this.actionPlansByLast12Months.loading = true;
        const res = await fetchActionPlansByLast12Months({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data.data;
        const totals = data.totals;
        this.$set(this.pendingImprovementActionsSpark, 'data', {total: totals.unfinished});
        this.$set(this.finishedImprovementActionsSpark, 'data', {total: totals.finished});
        const actionPlansByLast12Months = data.actionPlansByLast12Months;
        const last12Months = Object.keys(actionPlansByLast12Months);
        const labels = last12Months;

        this.pendingImprovementActionsSpark.options = {
          ...this.pendingImprovementActionsSpark.options,
          labels,
          subtitle: {
            ...this.pendingImprovementActionsSpark.options.subtitle,
          },
        };

        this.pendingImprovementActionsSpark.series = [
          {
            ...this.pendingImprovementActionsSpark.series[0],
            data: last12Months.map(
              (month) => actionPlansByLast12Months[month].unfinished
            ),
          },
        ];
        this.finishedImprovementActionsSpark.options = {
          ...this.finishedImprovementActionsSpark.options,
          labels,
          subtitle: {
            ...this.finishedImprovementActionsSpark.options.subtitle,
          },
        };
        this.finishedImprovementActionsSpark.series = [
          {
            ...this.finishedImprovementActionsSpark.series[0],
            data: last12Months.map(
              (month) => actionPlansByLast12Months[month].finished
            ),
          },
        ];
      } finally {
        this.actionPlansByLast12Months.loading = false;
      }
    },

    async fetchTotalInvestedByMonth() {
      if (this.totalInvestedByMonth.loading) {
        return;
      }
      try {
        this.totalInvestedByMonth.loading = true;
        const res = await getTotalInvestedByMonthApi({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.totalInvestedByMonth.data = data;
        const totalInvestedByMonth = data.totalInvestedByMonth;
        const values = Object.values(totalInvestedByMonth);
        const seriesData = values.map(({ date, total }) => ({
          x: date,
          y: total,
        }));
        this.totalInvestedByMonth.series = [
          {
            name: "Investimento",
            data: seriesData,
          },
        ];
        this.totalInvestedByMonth.options = {
          ...this.totalInvestedByMonth.options,
          xaxis: {
            ...this.totalInvestedByMonth.options?.xaxis,
            categories: values.map(({ date }) => date),
          },
        };
      } finally {
        this.totalInvestedByMonth.loading = false;
      }
    },

    async fetchTotalToInvestByMonth() {
      if (this.totalToInvestByMonth.loading) {
        return;
      }
      try {
        this.totalToInvestByMonth.loading = true;
        const res = await getTotalToInvestByMonthApi({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.totalToInvestByMonth.data = data;
        const totalToInvestByMonth = data.totalToInvestByMonth;
        const values = Object.values(totalToInvestByMonth);
        const seriesData = values.map(({ date, total }) => ({
          x: date,
          y: total,
        }));
        this.totalToInvestByMonth.series = [
          {
            name: "Investimento",
            data: seriesData,
          },
        ];
        this.totalToInvestByMonth.options = {
          ...this.totalToInvestByMonth.options,
          xaxis: {
            ...this.totalToInvestByMonth.options?.xaxis,
            categories: values.map(({ date }) => date),
          },
        };
      } finally {
        this.totalToInvestByMonth.loading = false;
      }
    },

    async fetchTotalToInvestPercentageByMonth() {
      if (this.totalToInvestPercentageByMonth.loading) {
        return;
      }
      try {
        this.totalToInvestPercentageByMonth.loading = true;
        const res = await getTotalToInvestPercentageByMonthApi({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        const percentageToInvest = data.percentageToInvest;
        this.totalToInvestPercentageByMonth.data = percentageToInvest;
      } finally {
        this.totalToInvestPercentageByMonth.loading = false;
      }
    },

    async loadHazardsByLast12Months() {
      if (this.hazardsByLast12Months.loading) {
        return;
      }
      try {
        this.hazardsByLast12Months.loading = true;
        const res = await fetchHazardsByLast12Months({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.$set(this.hazardsSpark, 'data', data);
        const hazardsByLast12Months = data.hazardsByLast12Months;
        const labels = Object.keys(hazardsByLast12Months);
        this.hazardsSpark.options = {
          ...this.hazardsSpark.options,
          labels,
          subtitle: {
            ...this.hazardsSpark.options.subtitle,
          },
        };
        this.hazardsSpark.series = [
          {
            ...this.hazardsSpark.series[0],
            data: labels.map((label) => hazardsByLast12Months[label].total),
          },
        ];
      } finally {
        this.hazardsByLast12Months.loading = false;
      }
    },

    async loadMachinesCountAndInvestmentsByHazard() {
      if (this.machinesCountAndInvestmentsByHazard.loading) {
        return;
      }
      try {
        this.machinesCountAndInvestmentsByHazard.loading = true;
        const res = await fetchMachinesCountAndInvestmentsByHazard({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.machinesCountAndInvestmentsByHazard.data = data;
        const machinesCountAndInvestmentsByHazard =
          data.machinesCountAndInvestmentsByHazard;

        this.investmentSeries.data = [];
        const hazardLevels = Object.values(HazardLevel);

        const newInvestmentData = hazardLevels.map(
          (level) => machinesCountAndInvestmentsByHazard[level].invested
        );
        this.investmentSeries = [
          {
            data: newInvestmentData,
          },
        ];
        const newPendingData = hazardLevels.map(
          (level) => machinesCountAndInvestmentsByHazard[level].budget
        );
        // const newMachineCountData = hazardLevels.map(
        //   (level) =>
        //     machinesCountAndInvestmentsByHazard[level]
        //       .machinesWithPendingPlansCount
        // );

        // Calcular investimento total (pendente + realizado)
        const totalInvestmentData = newPendingData.map((pending, index) => {
          return pending + newInvestmentData[index];
        });
        this.totalInvestmentSeries = [
          {
            name: "Investimento Total (R$)",
            data: totalInvestmentData,
          },
        ];

        this.machinesCountAndInvestmentsByHazard.series = [
          {
            ...this.machinesCountAndInvestmentsByHazard.series[0],
            data: newPendingData,
          },

        ];
        this.$nextTick(() => {
          const currentRiskDistributionMixedChart =
            this.$refs["current-risk-distribution-mixed-chart"];
          if (currentRiskDistributionMixedChart) {
            this.updateChartColor({
              el: currentRiskDistributionMixedChart.$el,
            });
          }
        });
      } finally {
        this.machinesCountAndInvestmentsByHazard.loading = false;
      }
    },

    async fetchMachinesCountByMonth() {
      if (this.machinesCountByMonth.loading) {
        return;
      }
      try {
        this.machinesCountByMonth.loading = true;
        const res = await getMachinesCountByMonthApi({
          unitId: this.unitSelected?.id,
          corporateGroupId: this.corporateGroupSelected?.id,
          sector: this.sectorSelected,
          businessType: this.businessTypeSelected,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.$set(this.machinesCountByMonth, 'data', data);
        this.$set(this.machineCountSpark, 'data', data);
        const machinesMonthlyCount = data.machinesMonthlyCount;
        const values = Object.values(machinesMonthlyCount);
        const seriesData = values.map(({ date, count }) => ({
          x: date,
          y: count,
        }));

        this.machinesCountByMonth.series = [
          {
            name: "Máquinas",
            data: seriesData,
          },
        ];

        this.machinesCountByMonth.options = {
          ...this.machinesCountByMonth.options,
          xaxis: {
            ...this.machinesCountByMonth.options?.xaxis,
            categories: values.map(({ date }) => date),
          },
        };

        this.machineCountSpark.options = {
          ...this.machineCountSpark.options,
          labels: values.map(({ date }) => date),
        };
        this.machineCountSpark.series = [
          {
            ...this.machineCountSpark.series[0],
            data: seriesData,
          },
        ];
      } finally {
        this.machinesCountByMonth.loading = false;
      }
    },

    async loadRisksPercentageByHazard() {
      if (this.risksPercentageByHazard.loading) {
        return;
      }
      try {
        this.risksPercentageByHazard.loading = true;
        const res = await fetchRisksPercentageByHazard({
          unitId: this.unitSelected?.id,
          businessType: this.businessTypeSelected,
          sector: this.sectorSelected,
          corporateGroupId: this.corporateGroupSelected?.id,
          machineId: this.machineSelected?.id,
        });
        const data = res.data;
        this.risksPercentageByHazard.data = data;
        const values = Object.values(data.risksPercentageByHazard);
        const seriesDataCurrent = values.map((item) => item.currentScore);
        const seriesDataBefore = values.map((item) => item.beforeScore);
        const seriesDataAfter = values.map((item) => item.afterScore);
        this.risksPercentageByHazard.series = [
          {
            name: "Antes",
            data: seriesDataBefore,
          },
          {
            name: "Durante",
            data: seriesDataCurrent,
          },
          {
            name: "Após",
            data: seriesDataAfter,
          },
        ];
        this.lineChartSeries = [
          {
            name: "Antes",
            data: seriesDataBefore,
          },
          {
            name: "Durante",
            data: seriesDataCurrent,
          },
          {
            name: "Após",
            data: seriesDataAfter,
          },
        ];

        this.pieChart.series.before.series = seriesDataBefore;
        this.pieChart.series.after.series = seriesDataAfter;
        this.pieChart.series.current.series = seriesDataCurrent;
      } catch (error) {
        this.$bvToast.toast("Erro ao buscar dados de risco", {
          variant: "danger",
          solid: true,
          title: "Ocorreu um erro",
        });
      } finally {
        this.risksPercentageByHazard.loading = false;
      }
    },

    updateChartColor(e) {
      const el = e.el;
      this.$nextTick(() => {
        const bars = el.querySelectorAll(".apexcharts-bar-area");
        const labels = el.querySelectorAll(
          ".apexcharts-xaxis-texts-g text tspan"
        );
        const labelTexts = Array.from(labels).map((label) =>
          label.textContent.trim()
        );

        bars.forEach((bar, index) => {
          const riskLevel = labelTexts[index];
          const color = this.getColorForRiskLevel(riskLevel);
          bar.style.fill = color;
          bar.style.stroke = color;
        });
      });
    },

    getColorForRiskLevel(level) {
      return this.hazardColors[level] || "#cccccc";
    },

    async loadRisksData() {
      try {
        await Promise.allSettled([
          this.loadRisksPercentageByHazard(),
          this.loadActionPlansByLast12Months(),
          this.fetchMachinesCountByMonth(),
          this.loadHazardsByLast12Months(),
        ]);
      } catch (error) {
        this.$bvToast.toast("Erro ao buscar dados de risco", {
          variant: "danger",
          solid: true,
          title: "Ocorreu um erro",
        });
      }
    },

    async loadStrategicData() {
      try {
        await Promise.allSettled([
          this.loadInvestedPercentileByHazard(),
          this.fetchTotalInvestedByMonth(),
          this.fetchTotalToInvestByMonth(),
          this.fetchTotalToInvestPercentageByMonth(),
          this.fetchMachinesCountByMonth(),
          this.loadMachinesCountAndInvestmentsByHazard(),
        ]);
      } catch (error) {
        this.$bvToast.toast("Erro ao buscar dados estratégicos", {
          variant: "danger",
          solid: true,
          title: "Ocorreu um erro",
        });
      }
    },
  },

  watch: {
    corporateGroupSelected: {
      async handler(newVal, oldVal) {
        if (!newVal || newVal === oldVal) return;

        const loader = this.$loading.show();
        try {
          this.resetKpiCards();
          this.resetCharts();

          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 100));

          await this.loadDataByCategory();
          this.$forceUpdate();
        } finally {
          loader.hide();
        }
      },
    },

    selectedFilters: {
      async handler(newVal, oldVal) {
        // Ignora se a empresa mudou (já tratado no watcher corporateGroupSelected)
        const corporateGroupChanged = oldVal && newVal[0]?.id !== oldVal[0]?.id;
        if (corporateGroupChanged) return;

        const loader = this.$loading.show();
        try {
          this.resetCharts();
          await this.loadDataByCategory();
        } finally {
          loader.hide();
        }
      },
      immediate: true,
      deep: true,
    },

    selectedDashboardCategory(newVal) {
      if (newVal === 1) {
        this.loadStrategicData();
        this.$nextTick(() => {
          const chart = this.$refs["current-risk-distribution-mixed-chart"];
          if (chart) {
            this.updateChartColor({ el: chart.$el });
          }
        });
      } else if (newVal === 0) {
        this.loadRisksData();
      }
    },
  },
};
</script>

<style lang="scss">
.shadow {
  box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.08);
}

.sparkboxes .box {
  padding-top: 10px;
  padding-bottom: 10px;
  text-shadow: 0 1px 1px 1px #666;
  box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.08);
  position: relative;
  border-radius: 5px;
}

.position-absolute {
  position: absolute !important;
}

.position-relative {
  position: relative !important;
}

.sparkboxes .box2 {
  background-color: none;
  max-height: 200px;
  height: 100%;
}

.sparkboxes .box3 {
  background-color: none;
  max-height: 200px;
  height: 100%;
}

.sparkboxes .box1 {
  background-color: none;
  max-height: 200px;
  height: 100%;
}

.sparkboxes .box4 {
  background-color: none;
  max-height: 200px;
  height: 100%;
}

.kpi-chart {
  &__text {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2.5rem;
    font-weight: bold;
    user-select: none;
    pointer-events: none;
  }

  &__display {
    opacity: 0.9;
  }
}

.font-xs {
  font-size: 12px;
}

.font-sm {
  font-size: 14px;
}

.height-fix {
  height: calc(100% - 1.5rem);
}

.pie-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pie-legend-label {
  display: inline-flex;
  align-items: center;
}

.pie-legend-download {
  color: #007bff;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}

.pie-legend-download.is-disabled {
  color: #b5b5b5;
  cursor: not-allowed;
}

#category_current .pie-legend-download {
  display: none;
  pointer-events: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
